// Ride's pages, for the rail: the roster, the board, the run of attempts,
// sponsor branding, and the mail switches.
//
// THESE HAD NO NAVIGATION AT ALL. Ride has taken a `panel` since the routes were
// written, and both values are reachable by typing the address, but nothing on
// the console ever offered the second one. So the tape of attempts existed, was
// routed, was rendered, and could be found only by somebody who already knew it
// was there. That is the whole reason this file exists.
//
// Shaped like RegistrationNav and KioskNav rather than sharing a component with
// them, because the thing they have in common is four lines of markup and the
// thing they do not is the panel type. One generic nav over three panel unions
// costs more in the signature than it saves in the body.

import type { ReactNode } from "react";
import type { RidePanel } from "../routes/route.js";

export type RideNavProps = {
  readonly panel: RidePanel;
  readonly onOpen: (panel: RidePanel) => void;
  readonly className?: string;
  /** Ride to Survive only. Other shows keep the three game pages. */
  readonly offerSponsor?: boolean;
  /** Ride to Survive only. The mail switches are not a send. */
  readonly offerMail?: boolean;
};

export const RIDE_NAV_ITEMS: readonly { readonly panel: RidePanel; readonly label: string }[] = [
  { panel: "roster", label: "All players" },
  { panel: "leaderboard", label: "Leaderboard" },
  { panel: "activity", label: "Activity" },
];

const SPONSOR_ITEM = { panel: "sponsor", label: "Sponsor" } as const;
const MAIL_ITEM = { panel: "mail", label: "Mail" } as const;

export function RideNav({
  panel,
  onOpen,
  className,
  offerSponsor = false,
  offerMail = false,
}: RideNavProps): ReactNode {
  const items = [
    ...RIDE_NAV_ITEMS,
    ...(offerSponsor ? [SPONSOR_ITEM] : []),
    ...(offerMail ? [MAIL_ITEM] : []),
  ];
  return (
    <nav className={className === undefined ? "seg2" : className} aria-label="Game pages">
      {items.map((item) => (
        <button
          key={item.panel}
          type="button"
          aria-current={item.panel === panel ? "page" : undefined}
          onClick={() => onOpen(item.panel)}
        >
          {item.label}
        </button>
      ))}
    </nav>
  );
}
